(function () {
  "use strict";

  angular
    .module("trakeyeApp")
    .controller("geofenceMaterialController", geofenceMaterialController);

  geofenceMaterialController.$inject = [
    "$scope",
    "AllGeofenceIDs",
    "geofenceMaterial",
  ];

  function geofenceMaterialController(
    $scope,
    AllGeofenceIDs,
    geofenceMaterial
  ) {
    var vm = this;

    vm.geofencesList = [];
    vm.selectedGeofenceId = null;
    vm.selectedGeofenceName = "";
    vm.loading = false;

    vm.resTxSummary = [];
    vm.incidentGroups = [];
    vm.cumulativeData = [];

    vm.incPage = 0;
    vm.incUiPage = 1;
    vm.incItemsPerPage = 10;
    vm.incTotalItems = 0;
    vm.today = new Date();

    vm.visibleIncidents = [];
    vm.getGeofenceList = function () {
      AllGeofenceIDs.getAll(function (response) {
        var list = response || [];
        var result = [];

        for (var i = 0; i < list.length; i++) {
          if (
            list[i].geofenceType === "MASTER" ||
            list[i].geofenceType === "MINI"
          ) {
            result.push({
              id: list[i].id,
              nameZone: list[i].name,
            });
          }
        }
        vm.geofencesList = result;
      });
    };
    vm.getGeofenceList();

    $scope.$watch("vm.selectedGeofenceId", function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        vm.incUiPage = 1;
        vm.incPage = 0;
        for (var i = 0; i < vm.geofencesList.length; i++) {
          if (vm.geofencesList[i].id === newVal) {
            vm.selectedGeofenceName = vm.geofencesList[i].nameZone;
            break;
          }
        }
        vm.loadMaterialData();
      }
    });
    vm.clearAll = function () {
      vm.resTxSummary = [];
      vm.incidentGroups = [];
      vm.cumulativeData = [];
      vm.visibleIncidents = [];
      vm.incTotalItems = 0;
    };

    vm.loadMaterialData = function () {
      if (!vm.selectedGeofenceId) return;

      vm.loading = true;
      vm.resTxSummary = [];
      vm.incidentGroups = [];
      vm.cumulativeData = [];
      vm.visibleIncidents = [];

      geofenceMaterial.getPage(
        { geofenceId: vm.selectedGeofenceId },
        vm.incPage,
        vm.incItemsPerPage,
        "last_modified_date,desc",
        function (data, headers) {
          vm.MaterialList = data || [];
          vm.incTotalItems = headers("X-Total-Count");
          vm.resTxSummary = vm.MaterialList;
          vm.incidentGroups = groupByIncident(vm.MaterialList);
          vm.visibleIncidents = vm.incidentGroups;
          vm.loadAllCumulativeData();
          vm.loading = false;
        },
        function () {
          vm.loading = false;
        }
      );
    };

    vm.incPageChanged = function () {
      vm.incPage = vm.incUiPage - 1;
      vm.loadMaterialData();
    };

    vm.toggleIncident = function (inc) {
      inc.expanded = !inc.expanded;
    };

    vm.toggleDate = function (dt) {
      dt.expanded = !dt.expanded;
    };
    function groupByIncident(list) {
      var map = {};
      var result = [];

      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var caseId = item.caseId || "NO INCIDENT";

        if (!map[caseId]) {
          map[caseId] = {
            caseId: caseId,
            mainDate: new Date(item.transactionDate),
            businessArea: item.businessAreaName,
            operationalArea: item.operationalAreaName,
            firstName: item.createdByUserFName,
            expanded: false,
            materials: {}   
          };
        }

        var material = item.materialName || "Unknown";
        var type = item.transactionType;
        var units = Number(item.noOfUnits) || 0;

        if (!map[caseId].materials[material]) {
          map[caseId].materials[material] = {
            materialName: material,
            unit: item.unitOfMeasurement,
            REQUESTED: 0,
            RECEIVED: 0,
            UTILIZED: 0,
            WASTAGE: 0,
            RECOVERED: 0,
            txItems: [] 
          };
        }

        map[caseId].materials[material][type] += units;
        map[caseId].materials[material].txItems.push(item);
      }

      for (var k in map) {
        map[k].materialList = [];

        for (var m in map[k].materials) {
          var row = map[k].materials[m];
          row.STOCK = row.REQUESTED + row.RECOVERED;
          map[k].materialList.push(row);
        }

        result.push(map[k]);
      }

      result.sort(function (a, b) {
        return b.mainDate - a.mainDate;
      });

      return result;
    }

    vm.formatUnit = function (value, unit) {
      value = value || 0;
      if (!unit) return value;

      unit = unit.toLowerCase();

      if (unit.indexOf("meter") !== -1 || unit.indexOf("mtr") !== -1) {
        return value + " Mtrs";
      }
      if (unit.indexOf("number") !== -1) {
        return value + " Numbers";
      }
      return value + " " + unit;
    };


    vm.downloadCSV = function () {

      if (!vm.visibleIncidents || !vm.visibleIncidents.length) {
        alert('No data available to download.');
        return;
      }

      var header = [
        'Ticket ID',
        'Date',
        'Block Name',
        'Business Area',
        'Operational Area',
        'First Name',
        'Material Name',
        'Unit',
        'REQUESTED',
        'RECEIVED',
        'UTILIZED',
        'RECOVERED',
        'STOCK'
      ];

      var rows = [header.join(',')];

      for (var i = 0; i < vm.visibleIncidents.length; i++) {

        var inc = vm.visibleIncidents[i];

        var dateStr = formatDateForCsv(inc.mainDate);

        for (var j = 0; j < inc.materialList.length; j++) {

          var m = inc.materialList[j];

          rows.push([
            quoteCsv(inc.caseId),
            quoteCsv(dateStr),
            quoteCsv(vm.selectedGeofenceName),
            quoteCsv(inc.businessArea || '-'),
            quoteCsv(inc.operationalArea || '-'),
            quoteCsv(inc.firstName || '-'),
            quoteCsv(m.materialName),
            quoteCsv(m.unit),
            quoteCsv(m.REQUESTED),
            quoteCsv(m.RECEIVED),
            quoteCsv(m.UTILIZED),
            quoteCsv(m.RECOVERED),
            quoteCsv(m.STOCK)
          ].join(','));
        }
      }

      var blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = vm.selectedGeofenceName+'_Material_Transactions.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };


    function quoteCsv(value) {
      if (value === null || value === undefined) return '""';
      return '"' + String(value).replace(/"/g, '""') + '"';
    }

    function formatDateForCsv(date) {
      var d = new Date(date);
      return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
    }


    function formatDate(date) {
      var d = new Date(date);
      return (
        ("0" + d.getDate()).slice(-2) +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        d.getFullYear()
      );
    }
   
    //open delete modal popup window
    vm.openDeleteMaterialModal = function (material, inc) {
      vm.selectedMaterial = material;
      vm.selectedInc = inc;
      vm.deletefail = false;
      angular.element("#deleteModal").modal("show");
    };

    //confirm delete material 
    vm.confirmDeleteMaterial = function () {
      var payload = [];

      for (var i = 0; i < vm.selectedMaterial.txItems.length; i++) {
        payload.push(vm.selectedMaterial.txItems[i].id);
      }

      geofenceMaterial.deleteLogMtrlTx(payload).then(
        function () {
          vm.selectedMaterial.txItems.forEach(function (tx) {
            var idx = vm.MaterialList.indexOf(tx);
            if (idx > -1) vm.MaterialList.splice(idx, 1);
          });
          vm.visibleIncidents = groupByIncident(vm.MaterialList);
          angular.element("#deleteModal").modal("hide");
          vm.clearDelete();
        },
        function () {
          vm.deletefail = true;
        }
      )
    };
    
    //clear delete modal
    vm.clearDelete = function () {
      vm.selectedMaterial = null;
      vm.selectedInc = null;
      vm.selectedIndex = null;
      vm.deletefail = false;
    };

    //edit material 
    vm.editMaterial = function (material, inc) {
      var lastTx = material.txItems[material.txItems.length - 1];

      vm.editMaterialData = angular.copy(lastTx);
      vm.selectedMaterial = material;
      vm.updating = false;

      angular.element("#editModal").modal("show");
    };

    //confirm edit material 
    vm.confirmEditMaterial = function () {
      vm.updating = true;

      var payload = [vm.editMaterialData];

      geofenceMaterial.updateLogMtrlTx(payload).then(
        function () {
          for (var i = 0; i < vm.MaterialList.length; i++) {
            if (vm.MaterialList[i].id === vm.editMaterialData.id) {
              vm.MaterialList[i].noOfUnits = vm.editMaterialData.noOfUnits;
              vm.MaterialList[i].transactionType =
                vm.editMaterialData.transactionType;
            }
          }

          vm.visibleIncidents = groupByIncident(vm.MaterialList);

          angular.element("#editModal").modal("hide");
          vm.clearEdit();
        },
        function () {
          vm.updating = false;
        }
      )
    };

    //clear edit modal
    vm.clearEdit = function () {
      vm.editMaterialData = null;
      vm.selectedInc = null;
      vm.selectedIndex = null;
      vm.updating = false;
    };
    vm.cumItemsPerPage = 10
    vm.loadAllCumulativeData = function () {
      if (!vm.selectedGeofenceId) return;

      vm.cumPage = 0;
      vm.cumulativeData = [];
      vm._grouped = {};

      fetchPage();
    };
    function fetchPage() {
      geofenceMaterial.getCumulativeSummary(
        vm.selectedGeofenceId,
        vm.cumPage,
        vm.cumItemsPerPage,
        function (data, headers) {
          if (!data || data.length === 0) {
            finalizeGroupedData();
            return;
          }
          data.forEach(function (item) {
            var name = item.materialName;

            if (!vm._grouped[name]) {
              vm._grouped[name] = {
                materialName: name,
                REQUESTED: 0,
                RECEIVED: 0,
                UTILIZED: 0,
                WASTAGE: 0,
                RECOVERED: 0
              };
            }
            var type = item.transactionType;
            vm._grouped[name][type] += item.totalNoOfUnits || 0;
          });
          vm.cumPage++;
          fetchPage();
        }
      );
    }

    function finalizeGroupedData() {
      vm.cumulativeData = [];

      for (var key in vm._grouped) {
        var row = vm._grouped[key];
        row.STOCK = (row.REQUESTED || 0) + (row.RECOVERED || 0);
        vm.cumulativeData.push(row);
      }
    }

    vm.downloadCumulativeCSV = function () {
      if (!vm.cumulativeData || !vm.cumulativeData.length) {
        alert("No data to download");
        return;
      }
      var csv = "Till Date,Material Name,REQUESTED,RECEIVED,UTILIZED,WASTAGE,RECOVERED,STOCK\n";
      var formattedDate =
        vm.today.getFullYear() + "-" +
        (vm.today.getMonth() + 1) + "-" +
        vm.today.getDate();
      vm.cumulativeData.forEach(function (row) {
        csv +=
          formattedDate + ',' +
          '"' + row.materialName + '",' +
          row.REQUESTED + ',' +
          row.RECEIVED + ',' +
          row.UTILIZED + ',' +
          row.WASTAGE + ',' +
          row.RECOVERED + ',' +
          row.STOCK + "\n";
      });

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var link = document.createElement("a");

      link.href = URL.createObjectURL(blob);
      link.download = vm.selectedGeofenceName+"_cumulative_report.csv";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
})();
